// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"500a3e8a","453":"67e000b3","726":"33c4a2ae","808":"1481a398"}[chunkId] + ".chunk.js";
};